import * as React from 'react';
import {useEffect, useMemo, useState} from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import useRootHook from '../../hooks/useRoot';
import stats from '../../models/stats';

export default function AggregateStatsTable({type, title, filters, dimension, metric}) {
    const {setShowLoader, defaultCurrency} = useRootHook();
    const [data, setData] = useState(null);

    const reqKey = useMemo(() => JSON.stringify({
        type,
        from: filters.from,
        to: filters.to,
        paymethod_id: filters.paymethod_id || null,
        project_id: filters.project_id || null,
    }), [type, filters.from, filters.to, filters.paymethod_id, filters.project_id]);

    useEffect(() => {
        setShowLoader(true);
        stats.getStats({type, ...filters})
            .then((resp) => {
                setShowLoader(false);
                setData(resp || {items: []});
            })
            .catch(() => setShowLoader(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reqKey]);

    const rows = data?.items || [];
    const subunit = data?.subunit || defaultCurrency?.subunit || 1;
    const symbol = defaultCurrency?.symbol || '';

    return (
        <React.Fragment>
            <Typography variant="subtitle1" sx={{ fontWeight: 900, mb: 1 }}>
                {title}
            </Typography>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>{dimension === 'project' ? 'Project' : 'Payment method'}</TableCell>
                        {metric === 'sum' && <TableCell align="right">Sum</TableCell>}
                        {metric === 'sum' && <TableCell align="right">Count</TableCell>}
                        {metric === 'status' && <TableCell align="right">Successful</TableCell>}
                        {metric === 'status' && <TableCell align="right">Declined</TableCell>}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((r) => {
                        const label =
                            dimension === 'project'
                                ? r['project.name'] || `#${r.project_id}`
                                : (r['paymethod.name']
                                    ? `${r['paymethod.name']}${r['paymethod->paysystem.key'] ? ` (${String(r['paymethod->paysystem.key']).toUpperCase()})` : ''}${r['paymethod.stripe_tag'] ? ` · ${r['paymethod.stripe_tag']}` : ''}`
                                    : `#${r.paymethod_id}`);

                        return (
                            <TableRow key={`${type}-${r.project_id || r.paymethod_id}`}>
                                <TableCell>{label}</TableCell>
                                {metric === 'sum' && (
                                    <TableCell align="right">
                                        {symbol}{(parseFloat(r.amount || 0) / subunit).toFixed(2)}
                                    </TableCell>
                                )}
                                {metric === 'sum' && <TableCell align="right">{r.count || 0}</TableCell>}
                                {metric === 'status' && <TableCell align="right">{r.completed_count || 0}</TableCell>}
                                {metric === 'status' && <TableCell align="right">{r.declined_count || 0}</TableCell>}
                            </TableRow>
                        );
                    })}
                    {rows.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={3}>
                                <Typography variant="body2" color="text.secondary">
                                    No data for selected range.
                                </Typography>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </React.Fragment>
    );
}


